export default {
  gameWidth: 500,
  gameHeight: 600,
  localStorageName: 'the-physical-book',
  resolution: window.devicePixelRatio
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 339
// module chunks = 0